import React, { useEffect, useState } from 'react'
import { useSecurityContext } from 'src/contexts/security.context'
import { useApiClient } from 'src/integrations/stock-reports-client/context'
import { Quote } from 'src/shared/quote.dto'

import { SecurityQuote } from './security-quote'

export const SecurityQuoteContainer = () => {
  const { security } = useSecurityContext()

  const defaultQuote: Quote = {
    price: security.ratios.general.lastClosePrice,
    lastTrade: '',
    change: '',
    changePercent: '',
  }

  const [isLoading, setIsLoading] = useState(true)
  const [quoteState, setQuoteState] = useState(defaultQuote)
  const apiClient = useApiClient()

  useEffect(() => {
    apiClient.getQuote(security.id).then(({ data }) => {
      setQuoteState(data)
      setIsLoading(false)
    })
  }, [])

  return (
    <SecurityQuote
      security={security}
      quote={quoteState}
      isLoading={isLoading}
    />
  )
}
